// extracted by mini-css-extract-plugin
module.exports = {"component":"SortControl_component__d7R_9"};